var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewMenuStrategyBuildericon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 3.48092,
    fill: "url(#paint0_linear_1350_3881)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "exclusion"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1350_3881",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 52,
    height: 52
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 3.48092,
    fill: "url(#paint1_linear_1350_3881)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1350_3881)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -37.2664,
    y: -6.16943,
    width: 113.967,
    height: 87.2542,
    rx: 3.48092,
    fill: "#599BEA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.3496 8.49536L44.6916 4.84753L42.0337 11.6166L43.1932 10.9356V22.7768L46.1899 21.0173V9.17634L47.3496 8.49536Z",
    fill: "url(#paint2_linear_1350_3881)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4337 9.65888L11.2671 6.61035L9.10034 12.2672L10.0455 11.6981V21.5934L12.4884 20.1231V10.2278L13.4337 9.65888Z",
    fill: "url(#paint3_linear_1350_3881)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3632 32.2908L45.3484 29.5255L43.3335 34.6568L44.2128 34.1405V43.1167L46.4843 41.7831V32.8068L47.3632 32.2908Z",
    fill: "url(#paint4_linear_1350_3881)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24298 33.6842L5.85508 30.4069L3.46704 36.4883L4.50874 35.8765V46.5145L7.20075 44.9339V34.2958L8.24298 33.6842Z",
    fill: "url(#paint5_linear_1350_3881)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1804 36.3287C21.1804 36.3287 21.3651 36.1328 21.748 36.2725C22.1298 36.4124 22.939 36.2404 23.3892 36.0249C23.8402 35.8092 24.3137 35.6901 24.8234 35.8766C25.3328 36.0627 25.3989 35.6114 25.3989 35.6114C25.4819 35.6418 25.7423 35.4957 25.8455 35.2043C25.9883 35.1361 26.4167 34.6889 26.0341 34.5489C25.9583 34.3858 25.9778 34.2204 25.4809 34.0387C24.9495 33.8349 24.3749 33.7761 23.8143 33.8683C23.9588 33.46 23.9993 33.1014 23.8522 32.7848C23.574 33.1439 23.4843 33.4292 22.9774 33.6718C22.4708 33.9144 21.8425 34.1341 21.7323 34.445C21.6224 34.7561 20.8555 35.123 20.8555 35.123L21.1804 36.3287Z",
    fill: "#FCD1A9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.895 36.6397C22.2937 35.9243 22.1262 35.2166 21.1571 34.7574C17.5356 34.8354 15.6678 35.5968 14.098 36.4995C12.2777 37.3714 11.2558 39.5556 13.1036 40.9672C15.909 39.2604 20.2966 37.0535 21.895 36.6397Z",
    fill: "#A3A9D0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8542 41.1523C23.3361 42.659 26.5278 44.001 27.2792 44.192C28.0302 44.001 31.2219 42.659 32.7035 41.1523C29.0899 40.9462 25.4678 40.9462 21.8542 41.1523Z",
    fill: "#4141AA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1643 34.9495V39.4941C21.1643 40.4129 21.7616 41.332 22.9552 42.033C25.3436 43.4349 29.2147 43.4344 31.6028 42.033C32.7967 41.3317 33.394 40.4129 33.3935 39.4941V34.9495H21.1643Z",
    fill: "url(#paint6_linear_1350_3881)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7604 37.263C33.756 37.1988 33.7361 37.1368 33.7023 37.0824C33.6686 37.028 33.622 36.983 33.5669 36.9514C33.6994 36.6426 33.7683 36.3095 33.7694 35.9726C33.7595 35.8786 33.7176 35.791 33.651 35.7251C33.5843 35.6591 33.4971 35.6189 33.4044 35.6115C33.2212 35.6115 33.4032 35.9726 33.4032 35.9726H33.3184C33.3184 36.869 32.7077 37.7217 31.5977 38.3736C29.219 39.7696 25.3482 39.7696 22.9695 38.3736C21.86 37.7222 21.2488 36.8693 21.2488 35.9726H21.155C21.155 35.9726 21.337 35.6115 21.1538 35.6115C21.0616 35.6178 20.9748 35.6579 20.9094 35.7243C20.844 35.7906 20.8045 35.8789 20.7981 35.9726C20.7992 36.308 20.8676 36.6396 20.999 36.9472C20.942 36.9783 20.8937 37.0236 20.8585 37.0788C20.8234 37.134 20.8026 37.1974 20.7981 37.263C20.7992 37.5982 20.8674 37.9297 20.9987 38.2371C20.9418 38.2683 20.8936 38.3136 20.8585 38.3688C20.8235 38.424 20.8027 38.4874 20.7981 38.5529C20.7981 39.6203 21.4892 40.6139 22.7443 41.3508C25.247 42.82 29.3199 42.82 31.8232 41.3508C33.0783 40.6139 33.7694 39.62 33.7694 38.5529C33.7614 38.4887 33.7389 38.4273 33.7038 38.3733C33.6687 38.3194 33.6219 38.2744 33.5669 38.2418C33.7008 37.9338 33.7668 37.5997 33.7604 37.263ZM31.5977 40.9537C29.219 42.3505 25.3482 42.3505 22.9695 40.9537C21.9276 40.3421 21.3252 39.5528 21.2557 38.7163C21.6446 39.274 22.1538 39.7338 22.7443 40.0607C25.247 41.5299 29.3199 41.5299 31.8232 40.0607C32.4134 39.7337 32.9225 39.274 33.3114 38.7166C33.2423 39.5525 32.6398 40.3421 31.5977 40.9537ZM31.5977 39.6638C29.219 41.0603 25.3482 41.0603 22.9695 39.6638C21.9276 39.0517 21.3252 38.2624 21.2557 37.4259C21.6447 37.9836 22.1538 38.4435 22.7443 38.7705C25.247 40.2394 29.3199 40.2394 31.8232 38.7705C32.4134 38.4433 32.9224 37.9834 33.3114 37.4259C33.2425 38.2624 32.6401 39.0517 31.5977 39.6638Z",
    fill: "url(#paint7_linear_1350_3881)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1121 24.1253C38.1128 22.3072 37.6709 20.5173 36.826 18.915C35.9811 17.3128 34.7595 15.9481 33.2699 14.9427C31.7804 13.9372 30.0694 13.3223 28.2894 13.1528C26.5094 12.9832 24.7158 13.2643 23.0686 13.9709C21.4213 14.6776 19.9717 15.7878 18.8489 17.2026C17.7261 18.6174 16.9651 20.2928 16.6338 22.0794C16.3024 23.866 16.411 25.7082 16.9498 27.4417C17.4886 29.1753 18.441 30.7463 19.7219 32.0146C20.5447 32.8547 20.7486 34.3731 20.7486 34.7992C20.7486 35.7808 21.3862 36.7619 22.6615 37.5108C25.2121 39.0084 29.3469 39.0079 31.897 37.5108C33.1723 36.7619 33.8098 35.7808 33.8098 34.7992C33.8098 34.3731 34.0138 32.8547 34.844 32.0102C35.8796 30.985 36.7025 29.7589 37.2638 28.4046C37.8252 27.0502 38.1136 25.5951 38.1121 24.1253Z",
    fill: "url(#paint8_radial_1350_3881)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M22.6615 32.0883C25.2122 30.5907 29.3466 30.5907 31.897 32.0883C34.4474 33.5856 34.4474 36.0132 31.897 37.5108C29.3469 39.0079 25.2122 39.0084 22.6615 37.5108C20.1109 36.0132 20.1109 33.5854 22.6615 32.0883Z",
    fill: "url(#paint9_linear_1350_3881)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M33.1108 33.0775C33.4209 33.4258 33.6401 33.8476 33.7484 34.3043L33.846 34.3617C33.8784 34.1045 33.9312 33.8505 34.0041 33.6021L33.1108 33.0775Z",
    fill: "url(#paint10_linear_1350_3881)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6331 24.9259C18.5297 24.9259 18.4274 24.9052 18.3319 24.865C18.2364 24.8248 18.1496 24.7658 18.0765 24.6915C18.0034 24.6172 17.9454 24.5289 17.9058 24.4318C17.8663 24.3346 17.8459 24.2305 17.8459 24.1254C17.8488 21.5821 18.8435 19.1437 20.6119 17.3453C22.3804 15.5469 24.7781 14.5353 27.279 14.5325C27.4878 14.5325 27.688 14.6168 27.8356 14.7669C27.9832 14.9171 28.0662 15.1207 28.0662 15.333C28.0662 15.5453 27.9832 15.7489 27.8356 15.899C27.688 16.0492 27.4878 16.1335 27.279 16.1335C25.1955 16.1359 23.1979 16.9787 21.7247 18.4769C20.2514 19.9752 19.4227 22.0066 19.4203 24.1254C19.4203 24.2305 19.4 24.3346 19.3604 24.4318C19.3209 24.5289 19.2629 24.6172 19.1898 24.6915C19.1167 24.7658 19.0299 24.8248 18.9344 24.865C18.8389 24.9052 18.7365 24.9259 18.6331 24.9259Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M29.6997 22.8189C29.6338 22.7789 29.5584 22.7581 29.4816 22.7587C29.4049 22.7592 29.3297 22.7811 29.2644 22.822C28.9656 22.9976 28.7434 23.5714 28.5997 24.3008C28.5031 24.0087 28.3762 23.7887 28.2125 23.6923C28.1465 23.6524 28.071 23.6316 27.9942 23.6322C27.9175 23.6327 27.8423 23.6546 27.7769 23.6955C27.4783 23.8714 27.2559 24.4444 27.1124 25.1738C27.0156 24.8822 26.8887 24.6617 26.7252 24.5658C26.6593 24.5258 26.5838 24.5049 26.507 24.5054C26.4302 24.506 26.355 24.528 26.2896 24.569C25.9909 24.7443 25.7687 25.3181 25.625 26.047C25.5281 25.7554 25.4015 25.5352 25.2378 25.439C25.1718 25.3991 25.0963 25.3782 25.0195 25.3788C24.9427 25.3793 24.8675 25.4012 24.8021 25.4422C24.24 25.7723 23.9458 27.5052 23.9458 29.0463C23.9458 30.6156 24.3135 31.0794 24.6692 31.5276C25.0446 32.0016 25.4333 32.4915 25.4333 34.5858C25.4333 34.6466 25.457 34.7049 25.4992 34.7478C25.5415 34.7908 25.5988 34.8149 25.6585 34.8149C25.7182 34.8149 25.7755 34.7908 25.8178 34.7478C25.86 34.7049 25.8838 34.6466 25.8838 34.5858C25.8838 32.33 25.4251 31.751 25.0197 31.2405C24.6853 30.8181 24.3965 30.454 24.3965 29.0463C24.3965 27.2999 24.7593 26.0118 25.0225 25.8435C25.1681 25.9417 25.4335 26.7138 25.4333 28.1734C25.4333 28.2341 25.457 28.2924 25.4992 28.3353C25.5415 28.3783 25.5988 28.4024 25.6585 28.4024C25.7182 28.4024 25.7755 28.3783 25.8178 28.3353C25.86 28.2924 25.8838 28.2341 25.8838 28.1734C25.884 26.4264 26.2466 25.1383 26.51 24.9697C26.6553 25.0682 26.9208 25.8409 26.9208 27.2999C26.9207 27.33 26.9265 27.3598 26.9377 27.3877C26.949 27.4156 26.9656 27.4409 26.9865 27.4622C27.0075 27.4835 27.0323 27.5004 27.0597 27.512C27.087 27.5235 27.1164 27.5295 27.146 27.5295C27.1756 27.5295 27.2049 27.5235 27.2323 27.512C27.2597 27.5004 27.2845 27.4835 27.3054 27.4622C27.3264 27.4409 27.343 27.4156 27.3542 27.3877C27.3655 27.3598 27.3713 27.33 27.3712 27.2999C27.3712 25.5534 27.7338 24.2651 27.997 24.0968C28.1428 24.195 28.408 24.9671 28.408 26.4264C28.4079 26.4566 28.4137 26.4864 28.425 26.5143C28.4363 26.5422 28.4529 26.5676 28.4738 26.5889C28.4948 26.6103 28.5197 26.6272 28.5471 26.6388C28.5745 26.6503 28.6038 26.6563 28.6335 26.6563C28.6632 26.6563 28.6925 26.6503 28.7199 26.6388C28.7473 26.6272 28.7722 26.6103 28.7931 26.5889C28.8141 26.5676 28.8307 26.5422 28.842 26.5143C28.8533 26.4864 28.8591 26.4566 28.859 26.4264C28.859 24.6802 29.2216 23.3916 29.4845 23.2236C29.63 23.3223 29.8952 24.0944 29.8952 25.5534C29.8952 27.0028 29.5747 27.7924 29.2349 28.6286C28.8474 29.5818 28.408 30.6622 28.408 32.8397C28.4081 32.9004 28.432 32.9586 28.4742 33.0015C28.5165 33.0444 28.5738 33.0685 28.6335 33.0685C28.6932 33.0685 28.7505 33.0444 28.7928 33.0015C28.835 32.9586 28.8588 32.9004 28.859 32.8397C28.859 30.7532 29.2618 29.7619 29.6513 28.8032C30.0087 27.9243 30.3465 27.0938 30.3465 25.5534C30.3465 24.4147 30.1761 23.0987 29.6997 22.8189Z",
    fill: "url(#paint11_linear_1350_3881)"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2791 11.4844C27.1748 11.4844 27.0747 11.4422 27.0009 11.3671C26.9271 11.2921 26.8856 11.1903 26.8856 11.0841V6.13354C26.8856 6.02738 26.927 5.92557 27.0008 5.85051C27.0747 5.77544 27.1748 5.73328 27.2791 5.73328C27.3835 5.73328 27.4836 5.77544 27.5575 5.85051C27.6313 5.92557 27.6727 6.02738 27.6727 6.13354V11.0841C27.6727 11.1903 27.6312 11.2921 27.5574 11.3671C27.4836 11.4422 27.3835 11.4844 27.2791 11.4844ZM32.7422 12.9023C32.674 12.9022 32.6069 12.8841 32.5476 12.8497C32.4883 12.8153 32.4388 12.7658 32.404 12.7061C32.3692 12.6464 32.3502 12.5785 32.349 12.5091C32.3478 12.4397 32.3644 12.3711 32.3971 12.3102L34.0306 9.26656C34.0554 9.22043 34.0888 9.17971 34.1291 9.14674C34.1693 9.11376 34.2156 9.08916 34.2651 9.07435C34.3147 9.05954 34.3667 9.05482 34.4181 9.06043C34.4695 9.06605 34.5193 9.0819 34.5646 9.10709C34.61 9.13227 34.65 9.16629 34.6825 9.20722C34.7149 9.24814 34.7391 9.29516 34.7536 9.34559C34.7682 9.39601 34.7728 9.44887 34.7673 9.50112C34.7618 9.55338 34.7462 9.60402 34.7214 9.65015L33.0879 12.6938C33.054 12.7569 33.0041 12.8096 32.9432 12.8463C32.8824 12.883 32.813 12.9023 32.7422 12.9023ZM21.8158 12.9023C21.7451 12.9023 21.6756 12.883 21.6148 12.8463C21.5539 12.8096 21.504 12.7569 21.4701 12.6938L19.8368 9.65015C19.812 9.60401 19.7964 9.55336 19.7908 9.50108C19.7853 9.44881 19.7899 9.39593 19.8045 9.34547C19.819 9.29502 19.8432 9.24797 19.8757 9.20703C19.9081 9.16608 19.9481 9.13204 19.9935 9.10684C20.0389 9.08164 20.0887 9.06579 20.1401 9.06018C20.1915 9.05457 20.2435 9.05931 20.2931 9.07415C20.3427 9.08898 20.389 9.11361 20.4292 9.14662C20.4695 9.17964 20.5029 9.2204 20.5277 9.26656L22.161 12.3102C22.1937 12.3711 22.2102 12.4397 22.209 12.5091C22.2078 12.5785 22.1888 12.6464 22.154 12.7061C22.1192 12.7658 22.0697 12.8153 22.0104 12.8497C21.9511 12.8841 21.8841 12.9022 21.8158 12.9023Z",
    fill: "#FFE950"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 3.48092,
    fill: "#2549A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1350_3881",
    x1: 39.8667,
    y1: 5.23827e-7,
    x2: 0.859985,
    y2: 55.5734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51028F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388913,
    stopColor: "#220439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#632C1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1350_3881",
    x1: 39.8667,
    y1: 5.23827e-7,
    x2: 0.859985,
    y2: 55.5734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51028F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388913,
    stopColor: "#220439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#160829"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1350_3881",
    x1: 44.6916,
    y1: 21.897,
    x2: 37.2474,
    y2: 9.21839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#EAEDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1350_3881",
    x1: 11.267,
    y1: 20.8583,
    x2: 4.97172,
    y2: 10.3997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#EAEDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1350_3881",
    x1: 45.3484,
    y1: 42.45,
    x2: 39.7053,
    y2: 32.8388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#EAEDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1350_3881",
    x1: 5.85505,
    y1: 45.724,
    x2: -0.832797,
    y2: 34.3337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#EAEDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1350_3881",
    x1: 21.1643,
    y1: 39.0168,
    x2: 33.3935,
    y2: 39.0168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5555C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34318F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1350_3881",
    x1: 20.7981,
    y1: 39.0321,
    x2: 33.7694,
    y2: 39.0321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F7FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4141AA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1350_3881",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.9551 20.9628) scale(20.5705 20.9192)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD03E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FECD3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565,
    stopColor: "#FAC533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#F3B725"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    stopColor: "#E9A211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E19100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1350_3881",
    x1: 20.7486,
    y1: 34.7995,
    x2: 33.8098,
    y2: 34.7995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    stopColor: "#ECEFF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#E0E4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCE1F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1350_3881",
    x1: 33.312,
    y1: 32.9594,
    x2: 34.0611,
    y2: 34.2353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1350_3881",
    x1: 29.728,
    y1: 32.4614,
    x2: 25.4004,
    y2: 25.0906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.098,
    stopColor: "#2D2116"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#614830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#8E6946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#B28358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615,
    stopColor: "#CF9866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    stopColor: "#E3A770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#EFB076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3B378"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMenuStrategyBuildericon);
export default __webpack_public_path__ + "static/media/newMenuStrategyBuildericon.f3ec44cdadbb19c839d706570b5ddba8.svg";
export { ForwardRef as ReactComponent };